import * as Sentry from '@sentry/vue';
import {Integrations} from '@sentry/tracing';

export function sentryInit(app:any, router:any) {
    Sentry.init({
        app,
        dsn: 'https://bd334d55eb5f428887641a8c58d2bddc@internal-sentry.baijia.com/993',
        environment: process.env.NODE_ENV === 'development' ? 'development' : 'production',
        integrations: [
            new Integrations.BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(router)
            }),
        ],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
    });
    app.config.globalProperties.$sentry = Sentry;
}

export function sentryReport(msg:string, data:Record<string, any>) {
    const {tags, extra} = data;
    Sentry.captureException(new Error(msg), {tags, extra});
}
